module.exports = __webpack_public_path__ + "img/sign_in.694e3a76.jpg";